import React from 'react'
import {Field, reduxForm} from 'redux-form'
import {required, email, phone} from '../validators';
import {renderField} from "../formUtilities";


let ContactForm = props => {
  const {handleSubmit, invalid, submitting} = props;
  return <form onSubmit={handleSubmit}>
    <div className={'fields'}>
      <Field name="name"
             component={renderField}
             type="text"
             validate={required}
             placeholder='Name*'/>
      <Field name="email"
             component={renderField}
             validate={[required, email]}
             type="email"
             placeholder='Email*'/>
      <Field name="company"
             component={renderField}
             validate={required}
             type="text"
             placeholder='Company*'/>
      <Field name="phone"
             component={renderField}
             validate={[required, phone]}
             type="text"
             placeholder='Contact Number*'/>
      <div className={'field'}>
        <Field name="preferredHour"
               placeholder={'Preferred Hour*'}
               component="select">
          <option value={''} disabled>Preferred Hour*</option>
          <option value={'9am–12pm'}>9am–12pm</option>
          <option value={'12pm–3pm'}>12pm–3pm</option>
          <option value={'3pm–6pm'}>3pm–6pm</option>
        </Field>
      </div>
    </div>
    <button
      id={'contact-form-submit'}
      disabled={invalid}
      type="submit">{submitting ? 'Sending' : 'Send'}
    </button>
  </form>
};

ContactForm = reduxForm({
  form: 'contactForm',
  initialValues: {
    preferredHour: ''
  }
})(ContactForm);


export default ContactForm;



// WEBPACK FOOTER //
// ./src/parts/ContactForm.js